var ko = require('knockout');

function ContentLibraryCartViewModel() {
    var self = this;

    self.items = ko.observable([]);

    self.count = ko.computed(function() {
        return self.items().length;
    }, this);
}

module.exports = ContentLibraryCartViewModel;